<div id="kt_toolbar_container"
     [ngClass]="toolbarContainerCssClasses"
     class="d-flex flex-stack">
  <app-page-title #ktPageTitle
                  class="page-title d-flex"
                  [ngClass]="pageTitleCssClasses"></app-page-title>
  <!-- begin::Actions  -->
  <div class="d-flex align-items-center py-1">
    <!-- begin::Wrapper  -->
    <div class="me-4">
      <ng-content select=".subheadertoolbar"></ng-content>
    </div>
    <!-- end::Wrapper  -->
    <!-- end::Button  -->
  </div>
  <ng-content select=".filter-container"></ng-content>

  <!-- end::Actions  -->
</div>
